// angular
// 	.module("HeroPRO")
// 	.factory("PipelineFilterFactory", pipelineFilterFactory);

import _ from 'lodash';

/* @ngInject */
export default function pipelineFilterFactory(PipelineMappings, $http, HPConfig, ModalService) {
    const filterOptions = {
        status: [],
        leadSource: [],
        salesRep: [],
        financingType: [],
        leadStatus: [{
            id: 1,
            value: 'green',
            label: 'Green',
        },
        {
            id: 2,
            value: 'yellow',
            label: 'Yellow',
        },
        {
            id: 3,
            value: 'red',
            label: 'Red',
        },
        {
            id: 4,
            value: 'grey',
            label: 'Grey',
        },
        ],
        fundingRequestStates: [],
    };

    function buildStatesFilterOptions(states) {
        let transformedStatuses = _.map(states, state => ({
            id: state.LoanStateId,
            value: state.LoanStateId,
            label: state.Description,
            pipelineStageId: state.PipelineStageId,
        }));
        transformedStatuses = _.sortBy(transformedStatuses, 'label');
        filterOptions.status = transformedStatuses;
    }

    function buildFinDocStatesFilterOptions(states) {
        let transformedStatuses = _.map(states, state => ({
            id: state.FinDocsStateId,
            value: state.FinDocsStateId,
            label: state.Description,
            pipelineStageId: state.PipelineStageId,
        }));
        transformedStatuses = _.sortBy(transformedStatuses, 'label');
        filterOptions.finDocStatus = transformedStatuses;
    }

    function buildFundingStatesFilterOptions(states) {
        let transformedStatuses = _.map(states, state => ({
            id: state.FundingRequestStateId,
            value: state.FundingRequestStateId,
            label: state.Description,
            pipelineStageId: state.PipelineStageId,
        }));
        transformedStatuses = _.filter(transformedStatuses, status => status.id !== 1);
        transformedStatuses = _.sortBy(transformedStatuses, 'label');
        filterOptions.fundingRequestStates = transformedStatuses;
    }

    return {
        getStageColumns(stageId) {
            const columns = PipelineMappings.columns;
            const mappings = PipelineMappings.mappings[stageId];
            const dataset = _.map(mappings, (mapping) => {
                for (const key in columns) {
                    if (columns.hasOwnProperty(key) && key === mapping) {
                        return _.extend(columns[key], {
                            mapping,
                        });
                    }
                }
            });
            return dataset;
        },
        getSalesReps(payload) {
            $http({
                url: `${HPConfig.heroProApi}ContractorUser`,
                method: 'GET',
                cache: true,
                params: {
                    ContractorLocationIds: payload,
                },
            }).then((response) => {
                let transformedReps = _.map(response.data.Data, rep => ({
                    id: rep.ContractorUserId,
                    value: rep.ContractorUserId,
                    label: `${rep.FirstName} ${rep.LastName}`,
                }));
                transformedReps = _.sortBy(transformedReps, 'label');
                filterOptions.salesRep = transformedReps;
            });
        },
        getFilterOptions() {
            if (filterOptions.status.length === 0) {
                $http({
                    url: `${HPConfig.heroProApi}Loan/Filters`,
                    method: 'GET',
                    cache: true,
                }).then(
                    (response) => {
                        // Process  filter options
                        buildStatesFilterOptions(response.data.Data.LoanStates);
                        buildFinDocStatesFilterOptions(response.data.Data.FinDocsStates);
                        buildFundingStatesFilterOptions(response.data.Data.FundingRequestStates);
                    },
                    () => {
                        // Close Filter Modal if open. Display error page.
                        const modal = ModalService.getPipelineFilterModal();
                        if (modal !== undefined && modal !== null) {
                            modal.close();
                        }
                    },
                );
            }
            return filterOptions;
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/pipeline/filter/pipelineFilterFactory.js